<template>
  <form class="def-buy-one-click-form" @submit.prevent="handlerSubmit">
    <ModalComponentHeader>
      {{ messages.title }}
    </ModalComponentHeader>
    <ModalComponentBody>
      <DefInput
        name="name"
        :placeholder="messages.userName"
        :value="name"
        :required="true"
        @input="name = $event.target.value"
      />

      <DefPhone
        :placeholder="basketMessages.phone"
        name="phone"
        :value="phone"
        :required="true"
        :only-countries="['UA']"
        @inputPhone="phone = $event"
      />

      <DefButtonPrimary type="submit">
        {{ messages.btnSend }}
      </DefButtonPrimary>
    </ModalComponentBody>
  </form>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import DefInput from '@components/Def/DefInput/DefInput.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import useModal from '@use/useModal/useModal';
import DefBuyOneClickThanks from '@components/Def/DefBuyOneClick/DefBuyOneClickThanks.vue';
import Analytics from '@/utils/Analytics';
import DefPhone from '@components/Def/DefPhone/DefPhone.vue';
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import Recaptcha3 from '../../../utils/Recaptcha3';

export default {
  name: 'DefBuyOneClickForm',
  components: { ModalComponentBody, ModalComponentHeader, DefPhone, DefButtonPrimary, DefInput },
  props: ['result'],
  data() {
    return {
      phone: '',
      name: '',
      modal: useModal(),
    };
  },
  computed: {
    ...mapState({
      product: ({ product }) => product.data.product,
      messages: ({ basket }) => basket.data.messages?.oneClick,
      basketMessages: ({ basket }) => basket.data.messages,
      personal: ({ personal }) => personal.data,
    }),
    id() {
      return this.product?.offer?.id ?? this.product?.id;
    },
  },
  methods: {
    ...mapMutations({
      loaderStart: 'global/loaderStart',
      loaderStop: 'global/loaderStop',
    }),
    ...mapActions({
      createOrderByOneClick: 'basket/createOrderByOneClick',
    }),
    async handlerSubmit() {
      try {
        this.loaderStart();
        const token = await Recaptcha3.getSubmitToken();
        const responseData = await this.createOrderByOneClick({
          name: this.name,
          phone: this.phone,
          productId: this.id,
          quantity: this.product?.price?.quantity || 1,
          saveBasket: 'Y',
          'g-recaptcha-response': token,
        });

        const dataLayer = responseData?.dataLayer;
        const actionField = responseData?.dataLayer?.actionField;

        if (dataLayer) {
          Analytics.buyOneClick([...dataLayer.products], {
            transaction_id: actionField.id,
            affiliation: 'Online Store Sova',
            value: actionField.revenue,
            // tax: "4.90",
            shipping: actionField.shipping.price,
            currency: actionField.shipping.currency,
            coupon: actionField.coupon,
          });
        }
        this.modal.show(DefBuyOneClickThanks, { result: responseData }, { width: '500px' });
      } catch (err) {
        console.error(err);
      } finally {
        this.loaderStop();
      }
    },
  },
  mounted() {
    const { user_name, user_phone_number, user_first_name } = this.personal?.authInfo;
    this.name = user_first_name;
    this.phone = user_phone_number;
  },
};
</script>

<style lang="scss" scoped>
.def-buy-one-click-form {
  .def-button-primary {
    margin-top: 16px;
  }
  :deep(.def-input),
  :deep(.def-intl-phone) {
    margin-bottom: 16px;
  }
  :deep(.def-button-primary) {
    width: 100%;
  }
}
</style>
